<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<router-link to="/account/index" class="back-btn"><span></span>注销账号</router-link>
	</div>
	<div class="ld-panel-main">
		<el-steps :active="1" finish-status="success" simple style="margin-bottom: 30px;">
		    <el-step title="协议与反馈" />
		    <el-step title="账号信息检查" />
		</el-steps>
		<el-card class="box-card">
		    <template #header>
		      <div class="card-header">
		        <span>系统执行账号注销检查如下:</span>
		      </div>
		    </template>
			<div v-if="allCount > 0">
				<div class="tip"><el-text type="warning" size="large">您账号存在有效产品业务，不能删除!</el-text></div>
				<ul class="main">
					<li v-if="countData.cdnCount > 0"><el-text type="primary">*</el-text> 融合CDN业务数量<el-text :type="countData.cdnCount > 0 ? 'danger':'info'">{{countData.cdnCount}}</el-text>个</li>
					<li v-if="countData.cloudAlbCount > 0"><el-text type="primary">*</el-text> 云负载均衡正常运行数量<el-text :type="countData.cloudAlbCount > 0 ? 'danger':'info'">{{countData.cloudAlbCount}}</el-text>个</li>
					<li v-if="countData.cloudCount > 0"><el-text type="primary">*</el-text> 云服务器正常运行数量<el-text :type="countData.cloudCount > 0 ? 'danger':'info'">{{countData.cloudCount}}</el-text>台</li>
					<li v-if="countData.cloudMemcachedCount > 0"><el-text type="primary">*</el-text> 云数据库 Memcached 正常运行数量<el-text :type="countData.cloudMemcachedCount > 0 ? 'danger':'info'">{{countData.cloudMemcachedCount}}</el-text>台</li>
					<li v-if="countData.cloudMqCount > 0"><el-text type="primary">*</el-text> 云消息队列正常运行数量<el-text :type="countData.cloudMqCount > 0 ? 'danger':'info'">{{countData.cloudMqCount}}</el-text>台</li>
					<li v-if="countData.cloudMysqlCount > 0"><el-text type="primary">*</el-text> 云数据库 RDS MySQL 正常运行数量<el-text :type="countData.cloudMysqlCount > 0 ? 'danger':'info'">{{countData.cloudMysqlCount}}</el-text>台</li>
					<li v-if="countData.cloudRedisCount > 0"><el-text type="primary">*</el-text> 云数据库 Redis 正常运行数量<el-text :type="countData.cloudRedisCount > 0 ? 'danger':'info'">{{countData.cloudRedisCount}}</el-text>台</li>
					<li v-if="countData.dnsCount > 0"><el-text type="primary">*</el-text> DNS业务数量<el-text :type="countData.dnsCount > 0 ? 'danger':'info'">{{countData.dnsCount}}</el-text>个</li>
					<li v-if="countData.domainCount > 0"><el-text type="primary">*</el-text> 域名业务有效数量<el-text :type="countData.domainCount > 0 ? 'danger':'info'">{{countData.domainCount}}</el-text>个</li>
					<li v-if="countData.icpCount > 0"><el-text type="primary">*</el-text> 备案业务数量<el-text :type="countData.icpCount > 0 ? 'danger':'info'">{{countData.icpCount}}</el-text>台</li>
					<li v-if="countData.idcCount > 0"><el-text type="primary">*</el-text> 租用托管正常运行数量<el-text :type="countData.idcCount > 0 ? 'danger':'info'">{{countData.idcCount}}</el-text>台</li>
					<li v-if="countData.objCount > 0"><el-text type="primary">*</el-text> 对象存储业务数量<el-text :type="countData.objCount > 0 ? 'danger':'info'">{{countData.objCount}}</el-text>台</li>
					<li v-if="countData.smsCount > 0"><el-text type="primary">*</el-text> 短信业务数量<el-text :type="countData.smsCount > 0 ? 'danger':'info'">{{countData.smsCount}}</el-text>个</li>
					<li v-if="countData.vhostCount > 0"><el-text type="primary">*</el-text> 云虚拟主机产品正常运行数量<el-text :type="countData.vhostCount > 0 ? 'danger':'info'">{{countData.vhostCount}}</el-text>台</li>
					<li v-if="countData.sslCount > 0"><el-text type="primary">*</el-text> SSl证书业务数量<el-text :type="countData.sslCount > 0 ? 'danger':'info'">{{countData.sslCount}}</el-text>个</li>
				</ul>
			</div>
			<div class="tip" v-else><el-text type="success" size="large">您账号未有正常运行业务，可以注销!</el-text></div>
		</el-card>
		<el-button type="primary" @click="submitForm" style="margin-top: 30px;" v-if="allCount <= 0">确定注销</el-button>
	</div>
</template>

<script setup>
	import { ref,reactive,inject,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { checkhasproduct,deleteAccountOver } from '@/api/account'
	import sideNav from '../../components/sideNav.vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const pageTitle = 'account';
	const domain = inject('domain');
	const router = useRouter();
	const allCount = ref();
	const countData = ref();
	
	const fetchListF = () => {
		checkhasproduct().then((res) => {
			if(res.code === 200){
				allCount.value = parseInt(res.data.total);
				countData.value = res.data
			}
		})
	};
	const submitForm = () => {
		deleteAccountOver().then((res) => {
			if(res.code === 200){
				window.location.href = domain
			}
		})
	};
	
	
	onMounted(() => {
		fetchListF();
	});
	
</script>


<style lang="scss" scoped>
	.main{
		li{color: #666; line-height: 22px; margin: 6px 0;}
		span{margin: 0 3px;}
	}
	.tip{text-align: center;padding: 30px;overflow: hidden;}
</style>